/* eslint-disable react/require-default-props,react/no-unused-prop-types,react/prop-types */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classnames from 'classnames';

import { ProfileHeaderBackground } from './components/ProfileHeaderBackground';
import { ProfileHeaderAvatar } from './components/ProfileHeaderAvatar';
import { ProfileHeaderFullName } from './components/ProfileHeaderFullName';
import { ProfileHeaderLocation } from './components/ProfileHeaderLocation';
import {
  ProfileHeaderStats,
  ProfileHeaderStatsLoading,
} from './components/ProfileHeaderStats';
import { ProfileHeaderNav } from './components/ProfileHeaderNav';
import { ProfileHeaderMessageButton } from './components/ProfileHeaderMessageButton';
import { ProfileHeaderShare } from './components/ProfileHeaderShare';

import { SUCCESS_RETRIEVING_PROFILE_DETAILS } from '../../../../ReduxStorage/Profiles/constants';

export class ProfileHeader extends PureComponent {
  static propTypes = {
    page: PropTypes.string,
    pages: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        path: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        component: PropTypes.any,
      })
    ),
    activeUser: ImmutablePropTypes.map,
    user: ImmutablePropTypes.map,
    profilePage: ImmutablePropTypes.map,
    setProfilePreviewColor: PropTypes.func,
    hasEditAccess: PropTypes.bool, // Only the profile owner has edit access
    canChatWithProfileUser: PropTypes.bool.isRequired,

    updateUserFullName: PropTypes.func,
    updateProfileColor: PropTypes.func,

    updateProfilePageHeaderFloat: PropTypes.func,
    updateProfilePageScrollToNav: PropTypes.func,
    updateProfilePageHeaderColorPreview: PropTypes.func,
    updateProfilePageHeaderColorSaving: PropTypes.func,
    updateProfilePageHeaderColorPicker: PropTypes.func,
    updateProfilePageFullNamePreview: PropTypes.func,
    updateProfilePageFullNameEditing: PropTypes.func,
    updateProfilePageFullNameSaving: PropTypes.func,
    updateProfilePageFullNameWidth: PropTypes.func,
    updateProfilePageShareShow: PropTypes.func,
    updateProfilePageSetWarningCallback: PropTypes.func,

    profileShareLink: PropTypes.string,
  };

  static defaultProps = {
    user: Immutable.fromJS({}),
    profilePage: Immutable.fromJS({}),
  };

  promptSaveError = () => {
    // todo: show error message
  };

  render() {
    const {
      user,
      activeUser,
      profilePage,
      page,
      pages,
      updateProfileColor,
      updateUserFullName,
      hasEditAccess,
      canChatWithProfileUser,
      updateProfilePageHeaderColorPreview,
      updateProfilePageHeaderColorSaving,
      updateProfilePageHeaderColorPicker,
      updateProfilePageFullNamePreview,
      updateProfilePageFullNameEditing,
      updateProfilePageFullNameSaving,
      updateProfilePageFullNameWidth,
      updateProfilePageShareShow,
      updateProfilePageSetPageDirty,
      updateProfilePageSetWarningCallback,
      profileShareLink,
    } = this.props;

    const navBackgroundStyle = {
      backgroundColor: profilePage.get('headerColor'),
    };

    return (
      <div
        className={classnames('profile-header', {
          'profile-header-float': profilePage.get('headerFloat', false),
        })}
        id="profile-header"
      >
        <div className="profile-header-bar" id="profile-header-bar">
          <div
            className="profile-header-bar-background"
            style={navBackgroundStyle}
          />
          <div className="profile-header-content">
            <div
              className={classnames('profile-header-info', {
                'header-empty': user.isEmpty(),
              })}
            >
              <ProfileHeaderBackground
                user={user}
                profilePage={profilePage}
                hasEditAccess={hasEditAccess}
                updateProfilePageHeaderColorPreview={
                  updateProfilePageHeaderColorPreview
                }
                updateProfilePageHeaderColorSaving={
                  updateProfilePageHeaderColorSaving
                }
                updateProfilePageHeaderColorPicker={
                  updateProfilePageHeaderColorPicker
                }
                updateProfileColor={updateProfileColor}
              />
              <div className="header-info">
                <ProfileHeaderAvatar
                  user={user}
                  hasEditAccess={hasEditAccess}
                />
                <ProfileHeaderFullName
                  user={user}
                  profilePage={profilePage}
                  hasEditAccess={hasEditAccess}
                  updateUserFullName={updateUserFullName}
                  updateProfilePageFullNamePreview={
                    updateProfilePageFullNamePreview
                  }
                  updateProfilePageFullNameEditing={
                    updateProfilePageFullNameEditing
                  }
                  updateProfilePageFullNameSaving={
                    updateProfilePageFullNameSaving
                  }
                  updateProfilePageFullNameWidth={
                    updateProfilePageFullNameWidth
                  }
                />
                <ProfileHeaderLocation
                  user={user}
                  hasEditAccess={hasEditAccess}
                />
                {user.get('status') === SUCCESS_RETRIEVING_PROFILE_DETAILS && (
                  <div className="header-actions">
                    <ProfileHeaderShare
                      user={user}
                      page={page}
                      profilePage={profilePage}
                      updateProfilePageShareShow={updateProfilePageShareShow}
                      profileShareLink={profileShareLink}
                    />
                    {canChatWithProfileUser && (
                      <ProfileHeaderMessageButton
                        user={user}
                        activeUser={activeUser}
                      />
                    )}
                  </div>
                )}
                {user.get('status') === SUCCESS_RETRIEVING_PROFILE_DETAILS ? (
                  <ProfileHeaderStats user={user} />
                ) : (
                  <ProfileHeaderStatsLoading />
                )}
              </div>
            </div>
            {pages &&
              user.get('status') === SUCCESS_RETRIEVING_PROFILE_DETAILS && (
                <ProfileHeaderNav
                  user={user}
                  page={page}
                  pages={pages}
                  profilePage={profilePage}
                  updateProfilePageSetPageDirty={updateProfilePageSetPageDirty}
                  updateProfilePageSetWarningCallback={
                    updateProfilePageSetWarningCallback
                  }
                  updateProfilePageShareShow={updateProfilePageShareShow}
                />
              )}
          </div>
        </div>
      </div>
    );
  }
}
